import { defineMessages } from 'react-intl';

const scope = 'src.pages.ContractsPage.components.CancelLongTermContractForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Cancel Long Term Contract',
  },
  cancelTooltip: {
    id: `${scope}.cancelTooltip`,
    defaultMessage: 'Cancel',
  },
  confirmButtonLabel: {
    id: `${scope}.confirmButtonLabel`,
    defaultMessage: 'Confirm',
  },
  cancellationSourceLabel: {
    id: `${scope}.cancellationSourceLabel`,
    defaultMessage: 'Cancellation Source',
  },
  requestedDateLabel: {
    id: `${scope}.requestedDateLabel`,
    defaultMessage: 'Requested Date',
  },
  noticeEndDateLabel: {
    id: `${scope}.noticeEndDateLabel`,
    defaultMessage: 'New End Date',
  },
  cancelByUcmLabel: {
    id: `${scope}.cancelByUcmLabel`,
    defaultMessage: 'Cancelled by ucm',
  },
  cancelByCandidateLabel: {
    id: `${scope}.cancelByCandidateLabel`,
    defaultMessage: 'Cancelled by candidate',
  },
});
